import { render, staticRenderFns } from "./VentasPedidosReport.vue?vue&type=template&id=45d3a9bc&"
import script from "./VentasPedidosReport.vue?vue&type=script&lang=js&"
export * from "./VentasPedidosReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports